import * as React from "react";
import * as styles from "source/app/presentation/MainPanel/Workflows/BookOfMind/BookOfMind.css";
import { BookOfMindQuote } from "motw_core/DTOs/BookOfMindQuote";

export function DisplayQuoteParent({
    bomq,
    authorName,
    parentCollectionName,
    revealDelayMs,
}: {
    bomq: BookOfMindQuote;
    authorName?: string;
    parentCollectionName?: string;
    revealDelayMs?: number;
}) {
    const quoteAuthor = authorName ?? bomq.parent;
    return (
        <span
            className={
                revealDelayMs === undefined
                    ? undefined
                    : styles.quoteParentReveal
            }
            style={
                revealDelayMs === undefined
                    ? undefined
                    : { animationDelay: `${revealDelayMs}ms` }
            }
        >
            <span className={styles.quoteParent}>{quoteAuthor}</span>
            {parentCollectionName && (
                <span className={styles.quoteParentContext}>
                    {` · ${parentCollectionName}`}
                </span>
            )}
        </span>
    );
}
